import React from "react";
import { Layout } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ReactComponent as Close } from "assets/icons/close.svg";

const { Header } = Layout;

const BankActivationHeader = ({ title }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Header className={`px-5 w-full max-auto py-3 z-[99] bg-transparent`}>
      <div className="flex justify-between items-center ">
        <div />
        <div className="body-14px-regular ">
          <span className="text-gray-0">{t(`bank.${title}`)}</span>
        </div>
        <Close
          className="cursor-pointer close-icon"
          width={24}
          height={24}
          onClick={() => navigate("/card")}
        />
      </div>
    </Header>
  );
};

export default BankActivationHeader;
